// extracted by mini-css-extract-plugin
module.exports = {"info-text":"postInfo_info-text__J_zLg"};